export interface VenueCapacityFilterType {
  min: number
  max: number
}

export const initialVenueCapacityFilter: VenueCapacityFilterType = {
  min: 0,
  max: 0
};
